<template>
	<!-- 空间详情 -->
	<div class="space_detail_warp">
		<BaseDetail ref="baseDetail">
			<template slot="cont" scope="{info}">
				<div class="cont_warp">
					<img class="cont_top_img" :src="info.image" alt="">
					<div class="top_info">
						<div class="cont_top_title">{{info.title}}</div>
						<div class="behavior_box">
							<div>浏览 0 </div>
							<div class="behavior_list">
								<!-- <div class="behavior_item">
                                    <svg-icon icon-class="thumb" class-name="item_icon" /> 0
                                </div>
                                <div class="behavior_item">
                                    <i class="el-icon-star-off item_icon"  /> 0
                                </div> -->
								<div class="behavior_item" @click="praise">
									<svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
									{{operCount.dzs}}
								</div>
								<div class="behavior_item" @click="collect">
									<i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''" />
									{{operCount.scs}}
								</div>
								<!-- <div class="behavior_item">
                                    <i class="el-icon-share item_icon"/> 分享
                                </div> -->
							</div>
						</div>
						<div class="top_line">联系电话：</div>
						<div class="top_line">空间面积：</div>
						<div class="top_line">地址：</div>
						<div class="space_desc" v-html="info.intro"></div>
					</div>
				</div>
			</template>
		</BaseDetail>
	</div>
</template>

<script>
	import BaseDetail from '@c/BaseDetail'
	import {
		post
	} from '@u/request'
	import {
		mapGetters
	} from 'vuex'

	export default {
		name: 'spaceDetail',
		components: {
			BaseDetail
		},
		data() {
			return {
				operCount: {}
			}
		},
		computed: {
			...mapGetters([
				'readerId',
			]),
			contentId() {
				return this.$route.params.id
			}
		},
		watch: {
			'readerId'(value) {
				this.operinfo()
			}
		},
		methods: {
			async praise() {

				if (!this.readerId) {
					this.$store.commit('SET_VISIBLE_LOGIN', true);
					return
				}
				if (this.operCount.ydz) {
					this.$message.success('已经点赞啦！');
					return;
				}
				const params = {
					readerId: this.readerId,
					contentId: this.contentId
				}
				const {
					data
				} = await post('resource/praise/add', params)
				this.$message.success('点赞成功！')
				this.operinfo()
			},
			async collect() {
				if (!this.readerId) {
					this.$store.commit('SET_VISIBLE_LOGIN', true);
					return
				}
				if (this.operCount.ysc) {
					this.$message.success('已经收藏啦！');
					return;
				}
				const params = {
					readerId: this.readerId,
					contentId: this.contentId
				}
				const {
					data
				} = await post('resource/collect/add', params)
				this.$message.success('收藏成功！')
				this.operinfo()
			},
			async operinfo() {
				const params = {
					readerId: this.readerId,
					contentId: this.contentId
				}
				const {
					data
				} = await post('resource/showapi/operinfo', params);
				this.operCount = data;
			}
		},
		mounted() {
			this.$refs.baseDetail.videoLoad('venuerooms')
			this.$refs.baseDetail.loadCommentList('contentId')
			this.operinfo()
		}
	}
</script>

<style scoped lang="scss">
	.space_detail_warp {
		background: #f8f8f8;
		min-height: calc(100vh - 315px);

		.cont_warp {
			.cont_top_img {
				width: 100%;
				height: 392px;
				border-radius: 5px 5px 0 0;
			}

			.top_info {
				padding: 19px 30px 35px 30px;
				color: #656567;
				line-height: 1;
				font-size: 20px;
			}

			.cont_top_title {
				font-size: 24px;
				font-weight: 800;
				color: #000;
			}

			.top_line {
				padding-top: 16px;
			}

			.space_desc {
				margin-top: 120px;
				color: #7f7f7f;
			}

			.behavior_box {
				display: flex;
				align-items: center;
				font-size: 20px;
				color: #777;
				padding: 27px 0 20px;
			}

			.behavior_list {
				margin-right: auto;
				margin-left: 20px;
				display: flex;

				.behavior_item {
					width: 118px;
					height: 47px;
					line-height: 47px;
					text-align: center;
					border-radius: 5px;
					background: #f5f5f5;
					cursor: pointer;
					margin-left: 18px;
				}
			}

			.item_icon {
				font-size: 23px;
			}

			.active_icon {
				color: #a80000;
			}
		}
	}
</style>
